import {
    GET_COURT_CONFIG_DATA,
    GET_COURT_CONFIG_DATA_SUCCESS,
    GET_COURT_CONFIG_DATA_FAILURE,
    GET_DEFAULT_COURT_CONFIG_DATA,
    GET_DEFAULT_COURT_CONFIG_DATA_SUCCESS,
    GET_DEFAULT_COURT_CONFIG_DATA_FAILURE,
    SAVE_COURT_CONFIG_DATA,
    SAVE_COURT_CONFIG_DATA_SUCCESS,
    SAVE_COURT_CONFIG_DATA_FAILURE,
    UPDATE_FACILITIES_BASED_ON_CONFIG,
    UPDATE_SHOW_CONFIG_MODAL,
    UPDATE_SELECTED_FACILITY,
    UPDATE_SELECTED_DRAW_WITH_MATCHES,
    GET_UNSCHEDULED_DRAW_MATCHES,
    GET_UNSCHEDULED_DRAW_MATCHES_SUCCESS,
    GET_UNSCHEDULED_DRAW_MATCHES_FAILURE,
    UPDATE_DRAWS_LIST,
    UPDATE_DRAGGING_MATCH,
    UPDATE_SCHEDULED_MATCHES,
    UPDATE_UNSCHEDULED_DRAW_MATCHES,
    UPDATE_HAS_TIME_CONFLICTS,
    GET_SCHEDULED_MATCHES,
    GET_SCHEDULED_MATCHES_SUCCESS,
    GET_SCHEDULED_MATCHES_FAILURE,
    SAVE_SCHEDULE_MATCH,
    SAVE_SCHEDULE_MATCH_SUCCESS,
    UPDATE_DRAWS_WITH_SCHEDULED_MATCHES,
    SAVE_SCHEDULE_MATCH_FAILURE,
    MATCH_SETTINGS_UPDATE_SUCCESS,
    MATCH_SETTINGS_UPDATE_FAILURE,
    MATCH_SETTINGS_UPDATE,
    UPDATE_SELECTED_MATCH_IDS,
    DE_SCHEDULE_MATCHES,
    DE_SCHEDULE_MATCHES_SUCCESS,
    CLOSE_DRAWER,
    DE_SCHEDULE_MATCHES_FAILURE,
    CLEAR_COURT_SCHEDULAR_DATA,
    PUBLISH_SCHEDULED_MATCHES,
    PUBLISH_SCHEDULED_MATCHES_SUCCESS,
    PUBLISH_SCHEDULED_MATCHES_FAILURE,
    REVERT_SCHEDULED_MATCHES,
    REVERT_SCHEDULED_MATCHES_SUCCESS,
    REVERT_SCHEDULED_MATCHES_FAILURE,
    UPDATE_DRAW_MATCH_COUNT,
    ADJUST_SELECTED_MATCHES,
    ADJUST_SELECTED_MATCHES_SUCCESS,
    ADJUST_SELECTED_MATCHES_FAILURE,
} from '../actions/actionTypes/court-scheduler-types';
import {
    CONFLICT_MESSAGE_OTHER_MATCH_ON_COURT,
    CONFLICT_TITLE_RESCHEDULE,
} from '../utils/courtSchedular';

const updateDrawMatchCount = (drawsList, drawId, delta) => {
    return drawsList.map((parentDraw) => {
        if (parentDraw.id === drawId && (!parentDraw.childDraws || parentDraw.childDraws.length === 0)) {
            return {
                ...parentDraw,
                scheduledMatchCount: parentDraw.scheduledMatchCount !== null
                    ? parentDraw.scheduledMatchCount + delta
                    : null,
            };
        }
        if (parentDraw.childDraws?.length > 0) {
            return {
                ...parentDraw,
                childDraws: parentDraw.childDraws.map((childDraw) => {
                    if (childDraw.id === drawId) {
                        return {
                            ...childDraw,
                            scheduledMatchCount: childDraw.scheduledMatchCount !== null
                                ? childDraw.scheduledMatchCount + delta
                                : null,
                        };
                    }
                    return childDraw;
                }),
            };
        }
        return parentDraw;
    });
};

const initialState = {
    isLoadingConfig: false,
    defaultCourtConfig: null,
    selectedDate: null,
    selectedDateCourtConfig: null,
    facilitiesAvailable: [],
    selectedFacilityId: '',
    isSavingConfig: false,
    showConfigModal: false,
    drawsWithMatches: [],
    selectedDrawWithMatches: '',
    courtsOfSelectedFacility: [],
    unScheduledMatches: [],
    hasSavedSuccess: false,
    savingError: null,
    drawIdToScheduleMatches: null,
    drawsList: [],
    draggableMatch: null,
    showTimeConflictsError: false,
    timeConflictsTitle: CONFLICT_TITLE_RESCHEDULE,
    timeConflictsMessage: CONFLICT_MESSAGE_OTHER_MATCH_ON_COURT,
    isLoadingMatches: false,
    scheduledMatches: [],
    unPublishedMatchCount: 0,
    publishedDeletedDraftMatchCount: 0,
    lastPublishedDate: null,
    isSaving: false,
    isSavingError: false,
    matchesSaved: [],
    selectedMatchIds: [],
    isPublishing: false,
    isReverting: false,
};

function courtSchedulerReducer(state = initialState, action) {
    switch (action.type) {
        case GET_COURT_CONFIG_DATA:
            return {
                ...state,
                isLoadingConfig: true,
                selectedDate: action.payload.selectedDate,
                selectedDateCourtConfig: null,
            };
        case GET_COURT_CONFIG_DATA_SUCCESS:
            return {
                ...state,
                isLoadingConfig: false,
                selectedDateCourtConfig: action.payload.courtConfig,
            };
        case GET_COURT_CONFIG_DATA_FAILURE:
            return {
                ...state,
                isLoadingConfig: false,
                selectedDateCourtConfig: null,
            };
        case GET_DEFAULT_COURT_CONFIG_DATA:
            return {
                ...state,
                isLoadingConfig: true,
                defaultCourtConfig: null,
            };
        case GET_DEFAULT_COURT_CONFIG_DATA_SUCCESS:
            return {
                ...state,
                isLoadingConfig: false,
                defaultCourtConfig: action.payload.courtConfig,
            };
        case GET_DEFAULT_COURT_CONFIG_DATA_FAILURE:
            return {
                ...state,
                isLoadingConfig: false,
                defaultCourtConfig: null,
            };
        case UPDATE_FACILITIES_BASED_ON_CONFIG:
            return {
                ...state,
                facilitiesAvailable: action.payload.facilitiesAvailable,
            };
        case UPDATE_SELECTED_FACILITY:
            return {
                ...state,
                selectedFacilityId: action.payload.facilityId,
                courtsOfSelectedFacility: action.payload.courtsOfSelectedFacility,
            };
        case UPDATE_SELECTED_DRAW_WITH_MATCHES:
            return {
                ...state,
                selectedDrawWithMatches: action.payload.selectedDrawWithMatches,
            };
        case UPDATE_DRAWS_WITH_SCHEDULED_MATCHES:
            return {
                ...state,
                drawsWithMatches: action.payload.drawsWithMatches,
            };
        case SAVE_COURT_CONFIG_DATA:
            return {
                ...state,
                isSavingConfig: true,
            };
        case SAVE_COURT_CONFIG_DATA_SUCCESS:
        case SAVE_COURT_CONFIG_DATA_FAILURE:
            return {
                ...state,
                isSavingConfig: false,
            };
        case UPDATE_SHOW_CONFIG_MODAL:
            return {
                ...state,
                showConfigModal: action.payload.showConfigModal,
            };
        case GET_UNSCHEDULED_DRAW_MATCHES:
            return {
                ...state,
                drawIdToScheduleMatches: action.payload.drawId,
                unScheduledMatches: [],
            };
        case GET_UNSCHEDULED_DRAW_MATCHES_SUCCESS:
        case UPDATE_UNSCHEDULED_DRAW_MATCHES:
            return {
                ...state,
                unScheduledMatches: action.payload.unScheduledMatches,
            };
        case GET_UNSCHEDULED_DRAW_MATCHES_FAILURE:
            return {
                ...state,
                unScheduledMatches: [],
            };
        case UPDATE_DRAWS_LIST:
            return {
                ...state,
                drawsList: action.payload.drawsList,
            };
        case UPDATE_DRAGGING_MATCH:
            return {
                ...state,
                draggableMatch: action.payload.draggableMatch,
            };
        case UPDATE_SCHEDULED_MATCHES:
            return {
                ...state,
                scheduledMatches: action.payload.scheduledMatches,
            };
        case UPDATE_HAS_TIME_CONFLICTS:
            return {
                ...state,
                showTimeConflictsError: action.payload.hasTimeConflicts,
                timeConflictsTitle: action.payload.title || initialState.timeConflictsTitle,
                timeConflictsMessage: action.payload.message || initialState.timeConflictsMessage,
            };
        case GET_SCHEDULED_MATCHES:
            return {
                ...state,
                isLoadingMatches: true,
                scheduledMatches: [],
                unPublishedMatchCount: 0,
                publishedDeletedDraftMatchCount: 0,
                lastPublishedDate: null,
                matchesSaved: [],
            };
        case GET_SCHEDULED_MATCHES_SUCCESS:
            return {
                ...state,
                isLoadingMatches: false,
                scheduledMatches: action.payload.scheduledMatches,
                unPublishedMatchCount: action.payload.unPublishedMatchCount,
                publishedDeletedDraftMatchCount: action.payload.publishedDeletedDraftMatchCount,
                lastPublishedDate: action.payload.lastPublishedDate,
                matchesSaved: [],
            };
        case GET_SCHEDULED_MATCHES_FAILURE:
            return {
                ...state,
                isLoadingMatches: false,
                scheduledMatches: [],
                unPublishedMatchCount: 0,
                publishedDeletedDraftMatchCount: 0,
                lastPublishedDate: null,
                matchesSaved: [],
            };
        case SAVE_SCHEDULE_MATCH:
        case DE_SCHEDULE_MATCHES:
        case MATCH_SETTINGS_UPDATE:
        case ADJUST_SELECTED_MATCHES:
            return {
                ...state,
                isSaving: true,
                isSavingError: false,
                savingError: null,
                hasSavedSuccess: false,
            };
        case ADJUST_SELECTED_MATCHES_SUCCESS:
            return {
                ...state,
                isSaving: false,
                isSavingError: false,
                savingError: null,
            };
        case SAVE_SCHEDULE_MATCH_SUCCESS:
            return {
                ...state,
                isSaving: false,
                isSavingError: false,
                savingError: null,
                matchesSaved: action.payload.matchesSaved,
            };
        case DE_SCHEDULE_MATCHES_FAILURE:
        case SAVE_SCHEDULE_MATCH_FAILURE:
        case MATCH_SETTINGS_UPDATE_FAILURE:
        case ADJUST_SELECTED_MATCHES_FAILURE:
            return {
                ...state,
                isSaving: false,
                isSavingError: true,
                savingError: action.payload,
                hasSavedSuccess: false,
            };
        case MATCH_SETTINGS_UPDATE_SUCCESS:
            return {
                ...state,
                isSaving: false,
                isSavingError: false,
                savingError: null,
                matchesSaved: action.payload.matchesSaved,
                scheduledMatches: action.payload.scheduledMatches,
                hasSavedSuccess: true,
            };
        case UPDATE_SELECTED_MATCH_IDS:
            return {
                ...state,
                selectedMatchIds: action.payload.selectedMatchIds,
            };
        case DE_SCHEDULE_MATCHES_SUCCESS:
        case CLOSE_DRAWER:
            return {
                ...state,
                isSaving: false,
                savingError: null,
                isSavingError: false,
            };
        case PUBLISH_SCHEDULED_MATCHES:
            return {
                ...state,
                isPublishing: true,
            };
        case PUBLISH_SCHEDULED_MATCHES_SUCCESS:
        case PUBLISH_SCHEDULED_MATCHES_FAILURE:
            return {
                ...state,
                isPublishing: false,
            };
        case REVERT_SCHEDULED_MATCHES:
            return {
                ...state,
                isReverting: true,
            };
        case REVERT_SCHEDULED_MATCHES_SUCCESS:
        case REVERT_SCHEDULED_MATCHES_FAILURE:
            return {
                ...state,
                isReverting: false,
            };
        case UPDATE_DRAW_MATCH_COUNT:
            return {
                ...state,
                drawsList: updateDrawMatchCount(
                    state.drawsList,
                    action.payload.drawId,
                    action.payload.delta,
                ),
            };
        case CLEAR_COURT_SCHEDULAR_DATA:
            return initialState;
        default:
            return state;
    }
}

export default courtSchedulerReducer;
